<!-- *ngFor="let pet of pets | async; let i = index;" -->
<div
	role="presentation"
	class="{{ klassName }}__card-content"
>
	<section class="{{ klassName }}__heading">
		<epi-icon
			[use]="pet.species === 'Dog' ? 'dog-icon' : 'cat-icon'"
			size="44"
			color="primary"
		></epi-icon>
		<div
			role="presentation"
			class="{{ klassName }}__heading-info"
		>
			<p class="{{ klassName }}__heading-name">{{ truncatedPetName }}</p>
			<p class="{{ klassName }}__heading-pricing">
				<span class="{{ klassName }}__heading-pricing-amount">{{ pet.totalPremium | currency }}</span>
				<span class="{{ klassName }}__heading-pricing-modality">
					per <br /> {{ getFrequencyViewValue((paymentFrequency$ | async)) }}
				</span>
			</p>
		</div>
		<button
			*ngIf="showPetInfoToggle"
			class="{{ klassName }}__heading-show-more"
			[ngClass]="{ 'is--expanded': showFullPetInfo }"
			(click)="showFullPetInfo = !showFullPetInfo"
		>
			<epi-icon
				use="dropdown-carrot"
				size="18"
			></epi-icon>
		</button>
	</section>
	<ng-container *ngIf="showFullPetInfo">
		<section class="{{ klassName }}__pet u-margin-top-small">
			<p class="{{ klassName }}__pet-breed">{{ breedName }}</p>
			<p class="{{ klassName }}__pet-age">
				{{ age }}{{ pet.gender ? ', ' + pet.gender.toString() : '' }}
			</p>
			<p
				*ngIf="showEditButtons"
				class="{{ klassName }}__pet-actions"
			>
				<a qeBaseLink
					class="{{ klassName }}__pet-actions-item"
					(click)="editPet(pet.petId)"
					data-quat="action_breakdownRemovePet"
					class="n--minimal"
				>Edit Pet</a>
				<a qeBaseLink
					*ngIf="this.allowRemovePet$ | async"
					class="{{ klassName }}__pet-actions-item"
					class="n--minimal"
					(click)="removePet(pet.petId)"
					data-quat="action_breakdownRemovePet"
				>Remove Pet</a>
			</p>
		</section>
		<section class="{{ klassName }}__policy-type u-margin-top-small">
			<p class="{{ klassName }}__policy-type-descriptor">
				{{ pet.insuranceType && getInsuranceType(pet.insuranceType) }}
			</p>
			<a qeBaseLink
				*ngIf="showEditButtons"
				class="{{ klassName }}__policy-type-action"
				(click)="editPlan(pet.petId)"
				data-quat="action_breakdownEditPlan"
				data-gtm="editPlanButton"
				class="n--minimal"
			>
				Edit Plan
			</a>
		</section>
		<section class="{{ klassName }}__selections">
			<epi-infoline
				make-bold="value"
				data-quat="value_breakdownAnnualMaximum"
			>
				<span slot="key">Annual Maximum</span>
				<span slot="value">
					{{ annualReimbursementViewValue }}
				</span>
			</epi-infoline>
			<epi-infoline
				make-bold="value"
				data-quat="value_breakdownAnnualDeductible"
			>
				<span slot="key">Annual Deductible</span>
				<span slot="value">
					{{ annualDeductibleViewValue }}
				</span>
			</epi-infoline>
			<epi-infoline
				make-bold="value"
				data-quat="value_breakdownReimbursement"
			>
				<span slot="key">Reimbursement</span>
				<span slot="value">
					{{ reimbursementViewValue }}
				</span>
			</epi-infoline>
			<epi-infoline
				make-bold="value"
				data-quat="value_breakdownExamFees"
			>
				<span slot="key">Exam Fees</span>
				<!--TODO: Swap this to yes/no dynamic value once backend is set up-->
				<span slot="value">
					{{ examFeesViewValue }}
				</span>
			</epi-infoline>
			<epi-infoline
				make-bold="value"
				data-quat="value_breakdownPrescriptionDrugs"
			>
				<span slot="key">Prescription Drugs</span>
				<!--TODO: Swap this to yes/no dynamic value once backend is set up-->
				<span slot="value">
					{{ drugDentalViewValue }}
				</span>
			</epi-infoline>
			<!-- TODO: if wellness -->
			<epi-infoline
				*ngIf="pet.eligibleForWellness"
				break="top"
				make-bold="value"
				data-quat="value_breakdownWellness"
			>
				<span slot="key">Wellness Rewards</span>
				<span slot="value">
					{{ wellnessViewValue !== 'None' ? '$' : null }}{{ wellnessViewValue }}
				</span>
			</epi-infoline>
			<a qeBaseLink
				href="#"
				(click)="showCoveragesModal($event, pet.insuranceType)"
				data-quat="action_breakdownPlanDetails"
				class="n--minimal"
			>Plan Details</a>
		</section>
	</ng-container>
</div>